<template>
    <div class="telegram-container">
      <div v-if="pageTitle" class="page-head">
        <img v-if="headerLogo" :src="headerLogo" alt="" class="page-logo" />
        <h1 class="page-title">{{ pageTitle }}</h1>
        <p v-if="pageSubtitle" class="page-subtitle">{{ pageSubtitle }}</p>
      </div>
      <a-card class="telegram-card">
        <!-- 选项卡 -->
        <a-tabs v-model:activeKey="activeTab" class="telegram-tabs">
            <a-tab-pane key="stars" tab="Telegram星星">
            <stars-form  />
          </a-tab-pane>
          <a-tab-pane key="member" tab="Telegram会员">
            <member-form  />
          </a-tab-pane>
          
        </a-tabs>
      </a-card>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue';
  import MemberForm from '../components/MemberForm.vue';
  import StarsForm from '../components/StarsForm.vue';
  import { loadSpecialProduct } from '../util/specialProduct';

  
  export default {
    name: 'TgMenber',
    components: {
      MemberForm,
      StarsForm
    },
    setup() {
      const activeTab = ref('member');
      const referral_code = ref('');
      const pageTitle = ref('');
      const pageSubtitle = ref('');
      const headerLogo = ref('');
       onMounted(async () => {
        const params = new URLSearchParams(window.location.search);
        referral_code.value = params.get("code");
        const product = await loadSpecialProduct('tg_member', { title: 'Telegram会员' });
        pageTitle.value = product.title || 'Telegram会员';
        pageSubtitle.value = product.detail || '';
        headerLogo.value = product.src || '';
      });

      return {
        activeTab,
        pageTitle,
        pageSubtitle,
        headerLogo,
      };
    }
  };
  </script>
  
  <style scoped lang="less">
  .telegram-container {
    max-width: 600px;
    margin: 0 auto;
    background: #000;
  min-height: 100vh;  /* 确保背景色铺满整个视口 */
  padding: 0;
  color: #fff; /* 全局文字颜色设置为白色 */

  .page-head {
    padding: 20px 16px 8px;
    text-align: center;
  }
  .page-logo {
    max-width: 64px;
    max-height: 64px;
    margin-bottom: 8px;
  }
  .page-title {
    font-size: 20px;
    margin: 0 0 8px;
    color: #fff;
  }
  .page-subtitle {
    margin: 0;
    color: rgba(255,255,255,0.65);
    font-size: 14px;
  }
    
  
    .telegram-card {
    background: #1a1a1a; /* 卡片背景改为深灰色 */
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
    /* 增强选项卡样式 */
    :deep(.ant-tabs-nav) {
      margin: 0;
      padding: 0 0;
      background: #1a1a1a; /* 选项卡背景与卡片一致 */
      
      .ant-tabs-tab {
        padding: 12px 16px;
        font-size: 16px;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.65); /* 非激活标签文字颜色 */
        transition: all 0.3s;
        
        &:hover {
          color: #1890ff;
        }
      }
      
      .ant-tabs-tab-active {
        color: #1890ff;
        
        .ant-tabs-tab-btn {
            font-weight: 600;
            color: #1890ff; /* 激活标签文字颜色 */
        }
      }
      
      .ant-tabs-ink-bar {
        height: 3px;
        background: #1890ff;
      }
    }
    
    /* 内容区域样式 */
    :deep(.ant-tabs-content) {
      padding: 0;
      color: #fff; /* 内容区域文字颜色 */
      
    }

    /* 卡片标题样式 */
    :deep(.ant-card-head) {
      color: #fff;
      border-bottom-color: #333;
    }

    /* 全局覆盖Ant Design组件文字颜色 */
    :deep(.ant-radio-button-wrapper),
    :deep(.ant-input),
    :deep(.ant-form-item-label) {
      color: #fff;
    }

    /* 输入框背景色 */
    :deep(.ant-input) {
      background: #333;
      border-color: #444;
      color: #fff;
    }
  }
  }
  </style>